import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {autofill} from 'redux-form'
import {useFormName, useFormSectionPrefix} from 'hooks/reduxForm'
import {useGovernmentOffices} from '../HelloWork/useGovernmentOffices'

// @ts-expect-error
import {prefectureOptions, withPrefix} from 'FormFields'
// @ts-expect-error
import {BoxDouble, SelectField, Label} from 'jbc-front/components/Form'

interface LaborStandardsInspectionOfficeLProps {
  prefectureId?: string
}

export const LaborStandardsInspectionOfficeL: FC<LaborStandardsInspectionOfficeLProps> = ({prefectureId}) => {
  const dispatch = useDispatch()
  const formName = useFormName()
  const sectionPrefix = useFormSectionPrefix()
  const {data} = useGovernmentOffices(prefectureId || '', 'labor_standards_inspection_office_l', !prefectureId)
  const laborStandardsInspectionOfficeLOptions =
    data?.governmentOffices?.map(({id, dispName}) => ({value: id, label: dispName})) || []

  return (
    <div>
      <Label text="労働基準監督署" />
      <BoxDouble>
        <SelectField
          name="labor_standards_inspection_office_l_prefecture_id"
          label="都道府県"
          options={prefectureOptions}
          onChange={(_event, value, previousValue) => {
            if (value !== previousValue) {
              dispatch(autofill(formName, withPrefix(sectionPrefix, 'labor_standards_inspection_office_l_id'), null))
            }
          }}
        />
        <SelectField
          name="labor_standards_inspection_office_l_id"
          label="管轄の労働基準監督署"
          options={laborStandardsInspectionOfficeLOptions}
        />
      </BoxDouble>
    </div>
  )
}
